/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
var View = require('../../view/modal/returnOrder');
// var successModl = require('./CancelOrderSucceed');
var returnGoods = require('../../io/' + process.env.APP_ENV + '/order/returnGoods');  //  改申请退货
var OrderId, cause, imgListModel, imgList;
var Model = nb.define({
    parent: require('./Dialog'),
    mapping: {
        uploadImg: require('../../model/uploadImg/uploadImg'),
        cancelList: require('../../model/form/RadioList')
    },
    method: {
        init: function () {
            var self = this;
            this.set('modalName', 'return-goods');
            var cancelList = this.get('cancelList');
            var uploadImg = this.get('uploadImg');

            uploadImg.setOpts({
                // multiple: 'multiple', //可多选图片
                maxCount: 4,          //最大上传数量
                icon: 'icon-add'      //字体图标
            });

            this.onChange('onShow', function () {
                this.set('suggest', '');
                uploadImg.setOpts({
                    imgList: {
                        items: []
                    }
                });
                cancelList.set('activeIndex', 0);
            }, this);

            nb.model.onChange(nb.model.user, function (inEvent, inUser) {
                this._userId = parseInt(inUser.get('userId'));
                this._companyId = parseInt(inUser.get('companyId')); //companyId
            }, this);

            nb.model.onChange('requireReturnGoodsId', function (inEvent, inId) {
                OrderId = inId;
            }, this);

            //获取取消订单原因
            cancelList.onChange('selectedValue', function (inEvent, inValue) {
                cause = inValue;
            }, this);

            //上传图片
            uploadImg.onChange('selectedFile', function (inEvent, inFile) {
                imgList = []; //
                imgListModel = uploadImg.get('imgList').get('items');   //allItems

                if (imgListModel) {
                    if (imgListModel.length > 3) {
                        var flag = false;
                        var maxSize = 1;
                        $.each(inFile.files, function (inIndex, inItem) {
                            var size = Math.round(inFile.files[inIndex].size / 1024 / 1024);
                            if (size > maxSize) {
                                flag = true;
                                return false;
                            }
                        });
                        if (flag) {
                            self.set('imgUp', '');
                            return;
                        } else {
                            self.set('imgUp', 'disUp');
                        }
                        return;
                    } else {
                        self.set('imgUp', '');
                    }
                }
            });

            //删除图片
            uploadImg.onChange('deleteIndex', function () {
                self.set('imgUp', '');
            });

            //点击提交
            this.onChange('cancelOrderCause', function () {
                var self = this;
                var suggest = this.get('suggest') || '';
                imgListModel = uploadImg.get('imgList').get('items');   //allItems
                if (!suggest && suggest.trim().length === 0) {  //没有value 无评论
                    nb.toast.setOpts({
                        text: '请填写退货原因！',
                        status: 'danger'
                    });
                    return;
                }
                if (imgListModel.length === 0) {
                    nb.toast.setOpts({
                        text: '请上传凭证照片!',
                        status: 'danger'
                    });
                    return;
                }
                imgListModel = uploadImg.get('imgList').get('items');   //allItems
                $.each(imgListModel, function (inIndex, inItem) {
                    imgList.push({
                        img: inItem.get('src')
                    });
                });
                returnGoods({
                    data: {
                        userId: this._userId,
                        companyId: this._companyId,
                        imgList: imgList,
                        orderId: OrderId,
                        reasonId: cause,       //原因 cause
                        reason: suggest
                    },
                    scope: this,
                    success: function (inResp) {
                        self.set('hide', new Date());
                        nb.model.set('returnOrderSucceedState', inResp.msg);
                        // successModl.set('show', new Date())
                    }
                });

            }, this);

        },
        setData: function () {
            return {
                cn: {
                    title: '申请退货',
                    titleText: '温馨提示',
                    info: '订单退货成功后将无法恢复，请仔细考虑后在退货',
                    cancelTitle: '请选择退货原因',
                    cancelBtn: '提交',
                    closeBtn: '取消',
                    cancelList: {
                        items: [{
                            value: 1,
                            checked: true,
                            text: '质量问题'
                        }, {
                            value: 2,
                            text: '其他原因'
                        }]
                    },
                    imgText: '（上传图片必须清晰、完整、方向正确，支持jpg、png、bmp，大小不超过1M）,最多上传5张图片',
                    titleText2: '退款原因',
                    titleText3: '上传图片',
                    otherReasons: '请填写退款原因'
                },
                en: {
                    title: 'Refund',
                    titleText: 'Notice',
                    info: 'After refunded, the order will not be resumed. Please consider it carefully.',
                    cancelTitle: 'Reasons',
                    cancelBtn: 'Submit',
                    closeBtn: 'Close',
                    cancelList: {
                        items: [{
                            value: 1,
                            checked: true,
                            text: 'Quality problem'
                        }, {
                            value: 2,
                            text: 'Other reason'
                        }]
                    },
                    imgText: '(Uploading images must be clear, complete and in the right direction, support JPG, PNG, BMP, size can not exceeding 1M), upload 5 pictures at most.',
                    titleText2: 'Refund Reason',
                    titleText3: 'Upload Picture',
                    otherReasons: 'Please describe return reason.'
                }
            };
        }
    }
});
var model = new Model();
var view = new View;
view.setModel(model);
nb.model.onChange(nb.opts.clientReady, function () {
    view.$().appendTo(document.body);
}, this);

module.exports = model;

// , {
//     value: 7,
//         text: '其他原因'
// }
// , {
//     value: 3,
//         text: '重复下单／误下单'
// }, {
//     value: 4,
//         text: '其他渠道价格更低'
// }, {
//     value: 5,
//         text: '付款遇到问题'
// }, {
//     value: 6,
//         text: '不想买了'
// }
// var files = inFile.files;
// if (files.length > 4 ) {
//     // delete files[files.length];
//     nb.toast.setOpts({
//         text: '照片不能超过4张!',
//         status: 'danger'
//     });
//     return
// }
// delete uploadList[imgListModel.length];
// uploadList[4].val("");


//////////////////
// WEBPACK FOOTER
// ../src/js/model/modal/returnGoods.js
// module id = 175
// module chunks = 3 8